import { useParams } from "react-router-dom";
import { Download, Music, ShieldOff, Play } from "lucide-react";
import { FREE_SONG_KEY, FREE_SONG_EXPIRY, SONG } from "@/lib/catalog";
import { API } from "@/lib/api";

export default function Vault() {
  const { key } = useParams();
  const valid = key === FREE_SONG_KEY;
  const freeUrl = `${API}/free-song/${key}`;

  return (
    <div className="relative z-10 min-h-screen flex items-center justify-center px-6 grain">
      <div className="absolute inset-0 z-0">
        <img src={SONG.cover} alt="" className="w-full h-full object-cover opacity-20 blur-xl" />
        <div className="absolute inset-0 bg-[#0B0C10]/85" />
      </div>

      <div className="relative z-10 max-w-lg w-full text-center fade-up">
        {valid ? (
          <>
            <span className="font-mono-ui text-xs uppercase tracking-[0.3em] text-[#2ec5d6] flex items-center justify-center gap-2">
              <Music className="w-4 h-4" /> Secret Vault Unlocked
            </span>
            <img
              src={SONG.cover}
              alt={SONG.title}
              className="w-56 h-56 object-cover mx-auto mt-8 border border-white/10 shadow-[0_30px_80px_rgba(0,0,0,0.7)]"
            />
            <h1 className="font-serif-display text-5xl font-semibold mt-8">Pixels and Glass</h1>
            <p className="text-soft mt-4">
              You found the QR code — here's your free copy of the track. Enjoy.
            </p>

            <audio
              controls
              src={freeUrl}
              data-testid="vault-audio-preview"
              className="w-full mt-8"
            >
              Your browser does not support audio playback.
            </audio>

            <a
              href={freeUrl}
              data-testid="free-download-link"
              className="btn-gold inline-flex items-center gap-2 px-10 py-4 mt-8 font-mono-ui text-xs uppercase tracking-[0.2em]"
            >
              <Download className="w-4 h-4" /> Download Free (MP3)
            </a>
            <p className="text-soft text-xs mt-6 font-mono-ui" data-testid="vault-expiry">
              Free download available until {FREE_SONG_EXPIRY}.
            </p>
          </>
        ) : (
          <>
            <ShieldOff className="w-16 h-16 text-[#d6453a] mx-auto" />
            <h1 className="font-serif-display text-4xl mt-8">Access denied</h1>
            <p className="text-soft mt-4">
              This vault requires a valid access key. Scan the official QR code to unlock the free
              download.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
